import { t, useLanguage } from "@/lib/i18n";
import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import GoogleSignIn from "@/components/GoogleSignIn";

export default function AccountSettings() {
  useLanguage();
  const { user, ready, updateUser } = useAuth();
  if (!ready) return <p className="p-6">{t("Loading your account...")}</p>;
  if (!user || user.role === "guest") return <Navigate to="/login" replace />;
  return <main className="min-h-screen bg-[#FAF7F2] p-5"><section className="max-w-md mx-auto bg-white border rounded-xl p-6 space-y-5">
    <h1 className="font-serif text-3xl">{t("Account settings")}</h1>
    <p className="text-stone-600">{user.email || t("No email address added")}</p>
    {user.google_connected ? <p role="status">{t("Google is connected to your account.")}</p> : <>
      <p>{t("Connect the Google account with the same email to sign in with Google.")}</p>
      <GoogleSignIn link onSuccess={(data) => updateUser(data.user)} />
    </>}
    {!user.email_verified && <Link className="block text-amber-800 underline" to="/verify-email">{t("Verify your email")}</Link>}
    <Link className="block text-amber-800 underline" to="/change-password">{t("Change or set password")}</Link>
    <Link className="block text-amber-800 underline" to="/app">{t("Back to tree")}</Link>
  </section></main>;
}
